import './loaders.css';
const Loaders = () => {
    return(
        <>
            <div className="loader"></div>
        </>
    )
}

export default Loaders;
